// extracted by mini-css-extract-plugin
export var layoutContainer = "_b3-0";
export var layoutContainerNoRounding = "_b3-6";
export var layoutContainerOpen = "_b3-5";
export var layoutContainerResizing = "_b3-1";
export var mainContent = "_b3-2";
export var resizeDivider = "_b3-3";
export var slidePanel = "_b3-4";